export const ENDPOINTS = {
    DASHBOARD_BASE_URL: "https://service.eventhawkintegration.com",
    WORKFLOW_MS_BASE_URL: "https://service.eventhawkintegration.com/workflow-service",
    ADS_SERVICE_BASE_URL: "https://service.eventhawkintegration.com/ads-service/service/location-ads-data"
}

export const TOKENS = {
    DASHBOARD_AUTH_TOKEN: "yourrandomvariable"
}